import types from './types';
import { t } from 'i18next';

export default ({ type, request, data }) => {
  switch (type) {
    case types.GET_FULL_ROWS_FAILURE:
      return {
        title: t('message.title.error.get.full.rows.for.comparison'),
        type: 'error'
      };
    default:
      return false;
  }
};
